import React, { PropTypes } from 'react'
import {TweenMax, Power0} from 'gsap'

class LogoAnimation extends React.Component {


  constructor(){

      super()

      this.state = {
        logoOutStarted:false,
        minimumVisibilityOver:false,
      }

      this.animateLogoIn = this.animateLogoIn.bind(this);
      this.animateLogoOut = this.animateLogoOut.bind(this);
      this.minmumVisibilityComplete = this.minmumVisibilityComplete.bind(this)

    }

 animateLogoIn(){
    TweenMax.from(this.refs.logo,1,{autoAlpha:0,delay:.6,ease:Power0.easeNone})
 }

 animateLogoOut(){
    TweenMax.to(this.refs.logo,.7,{autoAlpha:0,ease:Power0.easeNone})

    setTimeout(()=>{this.props.callBack()},1000)

 }



 componentDidMount(){
    //this.props.callBack();
    this.animateLogoIn();
    setTimeout(this.minmumVisibilityComplete,1500)
 }

 minmumVisibilityComplete(){
   this.setState({minimumVisibilityOver:true})
   if(this.props.dataLoaded){
     //console.log("Minimun time reached");
     this.animateLogoOut();
   }
 }

 componentWillUpdate(newProps){

    if(newProps.dataLoaded===true && this.state.minimumVisibilityOver===true){
      //console.log("Data Loaded");
      this.animateLogoOut();
    }

 }




  render () {



    // assets/logo/logo_0000.png





    return(
        <div className="logo-animation" ref="logo">

            <img src="/assets/global/logo.svg" />

        </div>
    )

  }
}

export default LogoAnimation;



// WEBPACK FOOTER //
// ./src/modules/logoanimation/LogoAnimation.js